export default __webpack_public_path__ + "static/media/payment-management-white.537de53b.svg";